import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchCoursesInput, SearchCoursesOutput, AddModuleInput, RemoveModuleInput, UpdateModuleNameInput, UpdateModuleDescriptionInput } from '../../../PathItems'
import { CourseTypeDetails, PaymentReference, Thumbnail, Video } from '../../../Core/PathItems'
import { Published } from '../../Core/PathItems'
import { Lesson } from './Lessons/PathItems'

export class SearchCourses extends RequestOperation<SearchCoursesInput,SearchCoursesOutput[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.SearchCourses",
      "SEARCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateCourse extends RequestOperation<CreateCourseInput,Course> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.CreateCourse",
      "CREATE",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteCourse extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.DeleteCourse",
      "DELETE",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetCourse extends RequestOperation<object,Course> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.GetCourse",
      "GET",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseType extends MessageOperation<UpdateCourseTypeInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseType",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseSpeciesId extends MessageOperation<UpdateCourseSpeciesIdInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseSpeciesId",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseBreedIds extends MessageOperation<UpdateCourseBreedIdsInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseBreedIds",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseName extends MessageOperation<UpdateCourseNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseName",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseThumbnailUrl extends MessageOperation<UpdateCourseThumbnailUrlInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseThumbnailUrl",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseVideoUrl extends MessageOperation<UpdateCourseVideoUrlInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseVideoUrl",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseDuration extends MessageOperation<UpdateCourseDurationInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseDuration",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseDescription extends MessageOperation<UpdateCourseDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseDescription",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseTrainerId extends MessageOperation<UpdateCourseTrainerIdInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseTrainerId",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseLongDescription extends MessageOperation<UpdateCourseLongDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseLongDescription",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseCategories extends MessageOperation<UpdateCourseCategoriesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseCategories",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseSequentialCompletion extends MessageOperation<UpdateCourseSequentialCompletionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseSequentialCompletion",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCoursePaymentProductId extends MessageOperation<UpdateCoursePaymentProductIdInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCoursePaymentProductId",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class AddModule extends MessageOperation<AddModuleInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.AddModule",
      "ADD",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class RemoveModule extends MessageOperation<RemoveModuleInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.RemoveModule",
      "REMOVE",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateModuleName extends MessageOperation<UpdateModuleNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateModuleName",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateModuleDescription extends MessageOperation<UpdateModuleDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateModuleDescription",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCourseState extends MessageOperation<UpdateCourseStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Training.Courses.UpdateCourseState",
      "PATCH",
      ["CourseId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type CreateCourseInput = {
  courseId?: string | undefined
  name: string
  description?: string | undefined
  trainerId?: string | undefined
  /**
   * Valid values: person, pet
   */
  type: string
  speciesId?: string | undefined
  breedIds: string[]
  thumbnailUrl?: string | undefined
  videoUrl?: string | undefined
  longDescription?: string | undefined
  categories: string[]
}

export type Course = {
  id: string
  type: CourseTypeDetails
  name: string
  media: Media
  details: Details
  modules: Modules[]
  paymentReference: PaymentReference
  state: Published
}

export type Media = {
  thumbnail: Thumbnail
  video: Video
}

export type Details = {
  duration: number
  description: string
  trainerId?: string | undefined
  longDescription: string
  categories: string[]
  sequentialCompletion: boolean
}

export type Modules = {
  sortId: number
  module: Module
}

export type Module = {
  id: string
  name: string
  description: string
  lessons: SortedLessonItem[]
}

export type SortedLessonItem = {
  sortId: number
  lesson: Lesson
}

export type UpdateCourseTypeInput = {
  /**
   * Valid values: person, pet
   */
  type: string
}

export type UpdateCourseSpeciesIdInput = {
  speciesId?: string | undefined
}

export type UpdateCourseBreedIdsInput = {
  breedIds: string[]
}

export type UpdateCourseNameInput = {
  name: string
}

export type UpdateCourseThumbnailUrlInput = {
  url: string
}

export type UpdateCourseVideoUrlInput = {
  url: string
}

export type UpdateCourseDurationInput = {
  duration: number
}

export type UpdateCourseDescriptionInput = {
  description: string
}

export type UpdateCourseTrainerIdInput = {
  trainerId: string
}

export type UpdateCourseLongDescriptionInput = {
  longDescription: string
}

export type UpdateCourseCategoriesInput = {
  categories: string[]
}

export type UpdateCourseSequentialCompletionInput = {
  sequentialCompletion: boolean
}

export type UpdateCoursePaymentProductIdInput = {
  productId: string
}

export type UpdateCourseStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

